import React from "react"
import { Link } from "react-router-dom"
const Bottom = ({ history, firebase }) => (
  <div>
    <div className="instructor-banner">

      <div className="opacity opacity-two">
        <div className="container">
          <h4>Become A Professional</h4>
          <h2>Spread Your Skills Worldwide </h2>
          <Link to="/subscriptions" className="tran3s hvr-trim">Get Started Now</Link>
        </div>
      </div>
    </div>
    <div className="amazing-feature">
      <div className="container">
        <h2>Get Notified <br />About this Amazing Features</h2>
        <div className="row" >
          <div className="col-xs-6" >
            <div className="single-box float-right tran3s xcursor" onClick={() => history.push('/contact')}>
              <i className="flaticon-compose"></i>
              <h6><a href="#" className="tran3s">Write us</a></h6>
              <p>Whether you’re looking to start a new career or change your current one, Orsity help you become job ready.</p>
            </div>
          </div>
          {/* {firebase.auth.uid && <div className="col-xs-6">
            <div className="single-box tran3s xcursor" onClick={() => history.push('/signup')}>
              <i className="flaticon-light-bulb"></i>
              <h6><a href="#" className="tran3s">Sign up Now!!</a></h6>
              <p>Creating a free account will allow you to view all of the free courses orsity has to offer as well as tracking your progress as you learn.</p>
            </div>
          </div>} */}
          <div className="col-xs-6">
            <div className="single-box tran3s xcursor" onClick={() => history.push('/signup')}>
              <i className="flaticon-light-bulb"></i>
              <h6><a href="#" className="tran3s">Sign up Now!!</a></h6>
              <p>Creating a free account will allow you to view all of the free courses orsity has to offer as well as tracking your progress as you learn.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>)

export default Bottom